import { debounceTimeExecute } from '@shared/helpers/utils';

export default {
  install(Vue) {
    Vue.mixin({
      methods: {
        $showErrorMessage(message) {
          this.$notification.error({
            class: 'custom-notification error-message',
            message: 'Error',
            description: message
          });
        },
        $showMultiErrorMessage(messages) {
          const formatMessages = (messages || []).map(message => ({
            class: 'custom-notification error-message',
            message: 'Error',
            description: message
          }));
          debounceTimeExecute(formatMessages, this.$notification.error);
        },
        $showSuccessMessage(message) {
          this.$notification.success({
            class: 'custom-notification success-message',
            message: 'Success',
            description: message
          });
        },
        $showInfoMessage(message) {
          this.$notification.info({
            class: 'custom-notification info-message',
            message: 'Info',
            description: message
          });
        },
        $showWarningMessage(message) {
          this.$notification.info({
            class: 'custom-notification warning-message',
            message: 'Info',
            description: message
          });
        }
      }
    });
  }
};
